import React from 'react';
import jira from '../../assets/integrations/jira.svg';
import slack from '../../assets/integrations/slack.svg';
import outlook from '../../assets/integrations/outlook.svg';
import googleCalendar from '../../assets/integrations/google-calendar.svg';

// Official brand marks, bundled so they don't depend on third-party hosts.
const LOGOS = {
  jira: { src: jira, name: 'Jira' },
  slack: { src: slack, name: 'Slack' },
  outlook: { src: outlook, name: 'Outlook' },
  google: { src: googleCalendar, name: 'Google Calendar' },
};

// Decorative by default: the provider name is always written next to the logo.
export function ProviderLogo({ provider, size = 22, label = false, style }) {
  const logo = LOGOS[provider];
  if (!logo) return null;
  return (
    <img
      src={logo.src}
      alt={label ? logo.name : ''}
      width={size}
      height={size}
      className="provider-logo"
      style={{ objectFit: 'contain', flexShrink: 0, ...style }}
    />
  );
}

export default ProviderLogo;
